// Descrição: Componente selecionável que exibe uma lista de items no sidebar

import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Select, { selectClasses } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function SelectContent() {
  const [company, setCompany] = React.useState('');

  const handleChange = (event) => { // remove tipagem
    setCompany(event.target.value);
  };

  const handleClickCobreFacil = () => {
    window.open('https://cliente.cobrefacil.com.br/login/5LEYODK2RZP0W9ZWVQXM', '_blank', 'noopener,noreferrer');
  };

  const handlePanelCliente = () => {
    window.open('https://123crm.com.br', '_blank', 'noopener,noreferrer');
  };

  return (
    <Select
      labelId="company-select"
      id="company-simple-select"
      value={company}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Select company' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 295,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      <ListSubheader sx={{ pt: 0 }}>Serviços</ListSubheader>
      <MenuItem value="">
        <ListItemAvatar>
          <Avatar alt="123zap">
            <DevicesRoundedIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Painel 123zap" secondary="Gerenciamento de campanhas" />
      </MenuItem>

      <MenuItem value="painelCliente" onClick={handlePanelCliente}>
        <ListItemAvatar>
          <Avatar alt="123CRM">
            <DevicesRoundedIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Painel 123CRM" secondary="Gerenciamento de clientes" />
      </MenuItem>

      <MenuItem value="cobreFacil" onClick={handleClickCobreFacil}>
        <ListItemAvatar>
          <Avatar alt="Cobre Fácil">
            <DevicesRoundedIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Minhas faturas" secondary="Cobre Fácil" />
      </MenuItem>

    </Select>
  );
}
